<template>
    <div>
        <CallTypesSelector :value="value.call_types" @input="updateCallTypes" />
        <PeriodSelector :value="value.period" @input="updatePeriod" />
    </div>
</template>

<script>
import CallTypesSelector from './common/CallTypesSelector.vue';
import PeriodSelector from './common/PeriodSelector.vue';
import { createUpdaters } from '../widgetHelpers';

export default {
    components: {
        CallTypesSelector,
        PeriodSelector,
    },

    props: {
        value: {
            type: Object,
            required: true,
        },
    },

    methods: createUpdaters('period', 'call_types'),
};
</script>
